// Select component:
// - passes just the value to onChange
// - automatically sets the 'selected' prop on children

import styled from 'styled-components/macro';
import {themecolors} from "../utils/themecolors";

const Select = styled(({className, value, onChange, children, ...props}) => {
    const handleChange = (event) => {
        event.preventDefault();
        event.stopPropagation();
        onChange(event.currentTarget.value);
    };
    return (
        <select className={className} onChange={handleChange} value={value || ''} {...props}>
            {children}
        </select>
    );
})`
  border: ${({theme}) => theme.standard_border};
  background-color: ${({theme}) => theme.color.name === 'dark' ? theme.placeholder_blue_3 : themecolors.pure_white};
  padding: 12px;
  border-radius: 4px;
`;

export default Select;
